import { useEffect, useState } from 'react'
import { Button, Col, Image, Row } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useLoading } from '../../hooks/LoadingContext'
import api from '../../services/api'
import { formatDate } from '../../utils/format'

import GaugeWhite from '../../../src/assets/VehicleInfo/alert-icons/GaugeWhite.svg'
import GasPump from '../../../src/assets/VehicleInfo/alert-icons/GasPump.svg'
import Truck from '../../../src/assets/VehicleInfo/alert-icons/Truck.svg'
import Warning from '../../assets/VehicleInfo/alert-icons/Warning.svg'
import Engine from '../../assets/VehicleInfo/alert-icons/Engine.svg'
import Package from '../../assets/VehicleInfo/alert-icons/Package.svg'
import Flag from '../../assets/VehicleInfo/alert-icons/Flag.svg'
import HandPalm from '../../assets/VehicleInfo/alert-icons/HandPalm.svg'
import XCircle from '../../assets/VehicleInfo/alert-icons/XCircle.svg'
import StopCircle from '../../assets/VehicleInfo/alert-icons/StopCircle.svg'
import Swap from '../../assets/VehicleInfo/alert-icons/Swap.svg'
import ArrowRight from '../../assets/VehicleInfo/alert-icons/ArrowRight.svg'

import styles from './styles.module.css'

const rolesMap = {
  manager: { api: 'delivery-manager', web: 'gestor-entregas' },
  attendant: { api: 'attendant', web: 'atendente' },
}

const reportIconsMap = {
  vehicle_delivered: Flag,
  registered_refuelling: GasPump,
  registered_maintance: Engine,
  on_way_to_delivery: Truck,
  request_delivered: Package,
  speeding: GaugeWhite,
  suspicious_activity: Warning,
  traffic_violation: HandPalm,
  request_canceled: XCircle,
  delivery_interrupted: StopCircle,
  request_transfered: Swap,
  on_way_to_internal_transfer: ArrowRight,
}

function Notification({
  role,
  buttonText = '',
  notification,
  removeNotification,
  requestId,
  backgroundColor = '#fff',
  children,
}) {
  const [width, setWidth] = useState(window.innerWidth)

  const { setIsLoading } = useLoading()

  const navigate = useNavigate()

  function handleWindowSizeChange() {
    setWidth(window.innerWidth)
  }

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange)
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange)
    }
  }, [])

  const isMobile = width <= 768

  async function handleClick() {
    try {
      setIsLoading(true)
      await api.put(`/${rolesMap[role].api}/delivery-reports/${notification.id}/toggle-seen`)
      removeNotification(notification.id)
      toast.info('Notificação marcada como lida com sucesso!')
    } catch (err) {
      toast.error('Falha ao marcar a notificação como lida! Atualize a página.')
    }
    setIsLoading(false)
  }

  return (
    <Row
      className={styles.notificationContainer}
      style={{
        backgroundColor: backgroundColor,
      }}
    >
      <Col className={`${isMobile ? 'col-12' : 'col-8'} d-flex flex-row align-items-center`}>
        <Col className="col-xl-1 col-sm-2 d-none d-sm-block">
          <Image
            className={styles.notificationIcon}
            width={40}
            src={reportIconsMap[notification.type]}
          />
        </Col>
        <Col className="col-xl-11 col-sm-10 col-12">
          <div className={styles.notificationDate}>{formatDate(notification.created_at)}</div>
          <div
            style={{
              fontWeight: 500,
              fontSize: 16,
            }}
          >
            {notification.title}
          </div>
          <div>{children}</div>
        </Col>
      </Col>
      <div className="mt-md-0 mt-2 col-md-4 col-12 d-flex flex-md-row flex-column align-items-center justify-content-md-end justify-content-center">
        {notification.type === 'on_way_to_delivery' ||
          (notification.type === 'request_delivered' && (
            <Button
              className={styles.detailsButton + ' mt-md-0 mt-2 order-md-0 order-1 mx-3'}
              onClick={() => navigate(`/${rolesMap[role].web}/entregas/${requestId}`)}
            >
              Ver detalhes
            </Button>
          ))}
        {buttonText && (
          <Button className={styles.notificationButton} onClick={handleClick}>
            {buttonText}
          </Button>
        )}
      </div>
    </Row>
  )
}

export default Notification
